import {fetch} from "../../../utils/dataAccess";

export async function list(params = "") {
    const response = await fetch(`/lineitem/shippingmethods?${params}`);
    const retrieved = await response.json();

    return retrieved['hydra:member'];
}
